import React, { useContext, useEffect, useReducer, useState } from "react";

import { Form, Formik } from "formik";

import * as Yup from "yup";

import { useSelector } from "react-redux";
import TransaccionalContext from "../context/TransaccionalContext";

import {
  Card,
  CardContent,
  Button,
  Divider,
  Typography,
  TextField,
} from "@mui/material";

import { SCSLoadingButton } from "app/modules/common/components/Buttons/SCSButtons";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import {
  initialModalState,
  modalNotificacionReducer,
} from "app/modules/common/components/Modals/ModalHandleNotificaciones/modalNotificacionReducer";

import ModalHandleNotification from "app/modules/common/components/Modals/ModalHandleNotificaciones/ModalHandleNotification";
import useMerchantStorage from "../hooks/useMerchantPago";

import SpinnerLoadSrx from "app/modules/shared/components/SpinnerLoadSrx";

import { TIPO_PAGO } from "../constants/constants";

import {
  consultarEstadoCredito,
  crearGenerarLinkPago,
} from "../services/transaccionalService";
import ModalVerificarDatosCliente from "./ModalVerificarDatosCliente";

import { NumberFormatCustom } from "app/modules/shared/mask/mascaraInputDinero";

const CardInformacionLinkPago = () => {
  const { authUser } = useSelector(({ auth }) => auth);

  const { informacionTransaccional, setInformacionTransaccional } =
    useContext(TransaccionalContext);

  const [modalState, modalDispatch] = useReducer(
    modalNotificacionReducer,
    initialModalState
  );

  const [informacionPago, setInformacionPago] = useState({});
  const [modalVerificarDatos, setModalVerificarDatos] = useState(false);

  const [loadingPayment, setLoadingPayment] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const [idMerchantStorage, setIdMerchantStorage] = useMerchantStorage(
    "idMerchantStorage",
    null
  );

  useEffect(() => {
    const getValoresPagar = async () => {
      try {
        const respuestaValoresPagar = await consultarEstadoCredito(
          informacionTransaccional.identificacion,
          informacionTransaccional.idGrupo
        );

        console.log({ respuestaValoresPagar });

        if (respuestaValoresPagar.state) {
          setInformacionPago(respuestaValoresPagar.data);
          setIsLoading(false);
        } else {
          setIsLoading(false);
        }
      } catch (error) {
        setIsLoading(false);
        console.log(error);
      }
    };
    getValoresPagar();
  }, []);

  if (isLoading) {
    return <SpinnerLoadSrx />;
  }

  const validarGrupoPago = () => {
    if (Number(informacionTransaccional?.idGrupo === 1)) {
      return Number(995);
    } else {
      return Number(995);
    }
  };

  const handlePayment = (valorPagoCliente) => {
    //validacion de email y celular
    if (
      informacionPago?.email === "" ||
      informacionPago?.celular === "" ||
      !informacionPago?.email ||
      !informacionPago?.celular
    ) {
      modalDispatch({
        type: "SHOW_WARNING",
        title: "PAGA AQUI",
        message: `Estimado cliente, no se dispone de tus datos de correo electrónico y/o número de celular para enviarte la notificación correspondiente al pago que desea efectuar. Por favor, actualiza tus datos comunicándote con nuestro call center al 023811960.`,
      });

      return;
    }

    setInformacionPago((args) => ({
      ...args,
      valorPagarForm: Number(valorPagoCliente),
    }));

    setModalVerificarDatos(true);
  };

  const handlePaymentConfirm = async () => {
    setLoadingPayment(true);

    const informacionGenerarLink = {
      identificacion: informacionTransaccional?.identificacion,
      idReferencia: informacionPago.idCuenta,
      idLocal: validarGrupoPago(),
      idGrupo: Number(informacionTransaccional?.idGrupo),

      tipo: "CRED",
      origen: "WEB",

      valorAPagar: informacionPago?.valorPagarForm,

      celular: informacionPago?.celular ?? "",
      email: informacionPago?.email ?? "",
      esRecurrencia: false,

      usuario: authUser.key,
      host: authUser.estacion,
    };

    console.log({ informacionGenerarLink });

    try {
      const respuestaGenerarLink = await crearGenerarLinkPago(
        informacionGenerarLink
      );

      console.log(respuestaGenerarLink);

      if (respuestaGenerarLink?.mensaje?.codigo === "00") {
        const urlPago = respuestaGenerarLink?.url;

        setIdMerchantStorage(respuestaGenerarLink?.merchantId);

        setInformacionTransaccional((args) => ({
          ...args,
          stateVerificar: true,
          merchantId: respuestaGenerarLink?.merchantId,
          linkPayment: urlPago,
          verificarPayment: true,
        }));

        setTimeout(() => {
          window.open(urlPago, "_blank");
        }, 1000);
      } else {
        modalDispatch({
          type: "SHOW_WARNING",
          title: "PAGO",
          message: "No se ha podido obtener el link de pago.",
        });
      }

      setLoadingPayment(false);
    } catch (error) {
      console.log(error);

      setLoadingPayment(false);

      modalDispatch({
        type: "SHOW_ERROR",
        title: "PAGO",
        message: "No se ha podido obtener el link de pago.",
      });
    }
  };

  const handleValidarValor = (valorPagoCli) => {
    //console.log(informacionPago?.valorPagar);

    if (Number(valorPagoCli) <= 0.0) {
      return true;
    } else {
      return false;
    }
  };

  const validarValorClienteAfavor = (valorClienteNegativo) => {
    if (Number(valorClienteNegativo) <= 0) {
      return 0;
    }
    return valorClienteNegativo;
  };

  return (
    <main className="cardInformacionLinkPago_container">
      <section className="cardInformacionLinkPago_card">
        <Formik
          initialValues={{
            valorPagoCliente: validarValorClienteAfavor(
              informacionPago?.valorPagar
            ),
          }}
          validationSchema={Yup.object({
            valorPagoCliente: Yup.number()
              .typeError("Debe ser un número")
              .required("Valor requerido")
              .moreThan(0, "Debe ser mayor que 0"),
          })}
          onSubmit={(values) => {
            handlePayment(values.valorPagoCliente);
          }}
        >
          {({ values, handleChange, touched, errors, handleBlur }) => (
            <Form>
              <Card
                variant="outlined"
                sx={{ height: "50vh", borderRadius: "20px" }}
              >
                <CardContent
                  sx={{
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Typography
                    gutterBottom
                    sx={{
                      color: "text.primary",
                      fontSize: 25,
                      margin: "0.75rem",
                      fontWeight: "600",
                      "@media (max-width: 900px)": {
                        margin: "0.25rem",
                        fontSize: 20,
                      },
                    }}
                  >
                    {TIPO_PAGO.VALOR_PAGO}
                  </Typography>
                  <Divider sx={{ width: "100%" }} />
                  <Typography
                    variant="h4"
                    component="div"
                    sx={{
                      fontSize: 18,
                      margin: "0.5rem",
                      "@media (max-width: 900px)": {
                        fontSize: 14,
                      },
                    }}
                  >
                    {`Hola,`}
                  </Typography>
                  <Typography
                    variant="h4"
                    component="div"
                    sx={{
                      fontSize: 16,
                      margin: "0.5rem",
                      "@media (max-width: 900px)": {
                        margin: "0.1rem",
                        fontWeight: "700",
                        fontSize: 12,
                      },
                    }}
                  >
                    {`${informacionPago?.nombreCliente}`}
                  </Typography>
                  <Typography
                    variant="h4"
                    component="div"
                    sx={{
                      fontSize: 20,
                      margin: "0.5rem",
                      "@media (max-width: 900px)": {
                        fontSize: 14,
                      },
                    }}
                  >
                    {` Tu valor a pagar es: $ ${informacionPago?.valorPagar} `}
                  </Typography>

                  <Divider sx={{ width: "100%" }} />

                  <Typography
                    variant="h4"
                    component="div"
                    sx={{
                      fontSize: 20,
                      margin: "15px 0 10px 0",
                      margin: "0.5rem",
                      "@media (max-width: 900px)": {
                        fontSize: 14,
                      },
                    }}
                  >
                    {`Valor que deseas pagar : `}
                  </Typography>

                  <TextField
                    variant="standard"
                    fullWidth
                    id="valorPagoCliente"
                    name="valorPagoCliente"
                    value={`$${values?.valorPagoCliente /* || "0.00" */}`}
                    onChange={handleChange}
                    placeholder="$0.00"
                    sx={{
                      mb: 3,
                      px: 2,
                      "& .MuiInput-underline": {
                        borderBottomColor: "#2E2E2E",
                      },
                      "& .MuiInput-underline:focus": {
                        borderBottomColor: "#e1251b",
                      },
                      "& .MuiInput-underline:after": {
                        borderBottomColor: "#e1251b",
                      },

                      "@media (max-width: 900px)": {
                        fontSize: 10,
                      },
                    }}
                    InputProps={{
                      inputComponent: NumberFormatCustom,
                      /*  disableUnderline: true, */ // Quita la línea inferior
                      sx: {
                        fontSize: "2.7rem",
                        textAlign: "center",
                        justifyContent: "center",
                        "& input": {
                          textAlign: "center",
                          fontSize: "2.7rem",
                          /* fontWeight: "bold", */
                          color: "#2E2E2E", // Cambia el color del texto
                          "&::placeholder": {
                            color: "#BDBDBD", // Color del placeholder
                            opacity: 1, // Asegura que el color se aplique
                          },
                          "@media (max-width: 900px)": {
                            fontSize: 27,
                            margin: "0",
                          },
                        },
                      },
                    }}
                  />

                  <SCSLoadingButton
                    disabled={handleValidarValor(values?.valorPagoCliente)}
                    loading={loadingPayment}
                    size={75}
                    startIcon={<AttachMoneyIcon />}
                    titulo="Paga Aquí"
                    type="submit"
                  />
                </CardContent>
              </Card>
            </Form>
          )}
        </Formik>

        <ModalVerificarDatosCliente
          title={"Botón de Pago"}
          open={modalVerificarDatos}
          setOpen={setModalVerificarDatos}
          handlePaymentConfirm={handlePaymentConfirm}
        >
          <>
            <h4 style={{ fontSize: "13.5px" }}>{`Estimad@ cliente: `}</h4>

            <h4 style={{ textAlign: "left" }}>
              {`Te enviaremos la notificación de pago al correo `}
              <strong>{informacionPago?.email}</strong>
              {` y al celular `}
              <strong>{informacionPago?.celular}.</strong>
            </h4>
            <h4 style={{ textAlign: "left", margin: "0.3rem 0" }}>
              <li>
                {`Si los datos son correctos, presiona «Sí» para continuar.`}
              </li>
            </h4>
            <h4 style={{ textAlign: "left", margin: "0.3rem 0" }}>
              <li>
                {`Si necesita actualizarlos, presiona «No» y comuníquete con nuestro call center al 023811960.`}
              </li>
            </h4>

            <h4>
              <strong>¡Gracias por tu confianza!</strong>
            </h4>
          </>
        </ModalVerificarDatosCliente>

        <ModalHandleNotification
          parameters={modalState}
          setOpen={() => modalDispatch({ type: "CLOSE_MODAL" })}
        />
      </section>
    </main>
  );
};

export default CardInformacionLinkPago;
